// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f3be0f24","703":"8f04cef6"}[chunkId] + ".chunk.js";
};